// extracted by mini-css-extract-plugin
export default {"todoform":"TodoFrom_todoform__hQD+5"};